import { Division } from '../types/recruiter'

export const DIVISIONS = Object.values(Division)

export const DIVISION_LABELS: Record<Division, string> = {
  [Division.NCAA_D1]: 'NCAA Division I',
  [Division.NCAA_D2]: 'NCAA Division II',
  [Division.NCAA_D3]: 'NCAA Division III',
  [Division.NAIA]: 'NAIA',
  [Division.NJCAA]: 'NJCAA',
  [Division.CCCAA]: '3C2A',
  [Division.NWAC]: 'NWAC',
  [Division.NCCAA]: 'NCCAA',
  [Division.USCAA]: 'USCAA',
}
